import React from 'react';
import {
  InboxIcon,
  ChartPieIcon,
  CurrencyDollarIcon,
  HeartIcon,
  // DatabaseIcon, // Temporarily disabled - KEN-2408
  SearchIcon,
  TagIcon,
  UploadIcon,
  UserIcon,
  ViewGridIcon,
  DownloadIcon,
  DocumentReportIcon,
  TerminalIcon,
  HomeIcon,
  ChartBarIcon,
} from '@heroicons/react/outline';
import {HiOutlineWrench} from 'react-icons/hi2';

export interface NavigationLink {
  name: string;
  to: string;
  external?: boolean;
  exact?: boolean;
  hidden?: boolean;
  pathMatches?: string[];
  allowed?: (
    | 'customer'
    | 'data_partner'
    | 'internal'
    | 'admin'
    | 'terminalCustomer'
  )[];
  icon?: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}

export const navigationLinkGroups: NavigationLink[][] = [
  [
    {
      name: 'Projects',
      icon: HomeIcon,
      to: '/project',
      exact: true,
    },
    {
      name: 'Search',
      icon: SearchIcon,
      to: '/project',
      exact: true,
      pathMatches: ['/study'],
      hidden: true,
    },
    {
      name: 'Search (old)',
      icon: SearchIcon,
      to: '/search',
      pathMatches: ['/search'],
      allowed: ['internal'],
      hidden: true,
    },
    {
      name: 'Search (Internal)',
      icon: SearchIcon,
      to: '/project',
      pathMatches: ['/internal/search'],
      allowed: ['internal'],
      hidden: true,
    },
    {
      name: 'Patient Search',
      icon: SearchIcon,
      to: '/patient_search',
      pathMatches: ['/patient_search'],
      allowed: ['internal'],
      hidden: true,
    },
    {
      name: 'Advanced Search',
      icon: SearchIcon,
      to: '/advanced_search',
      pathMatches: ['/advanced_search'],
      allowed: ['internal'],
      hidden: true,
    },
    {
      name: 'Terminal',
      icon: TerminalIcon,
      to: '/terminal',
      pathMatches: ['/terminal', '/project/:project_id/terminal'],
      hidden: true,
    },
    {
      name: 'Terminal Internal',
      icon: TerminalIcon,
      to: '/internal/terminal',
      pathMatches: [
        '/internal/terminal',
        '/project/:project_id/internal/terminal',
      ],
      allowed: ['internal'],
      hidden: true,
    },
    {
      name: 'Datasets',
      to: '/datasets',
      icon: ViewGridIcon,
      allowed: ['customer', 'internal'],
    },
    {
      name: 'Saved Searches',
      to: '/saved-searches',
      icon: HeartIcon,
    },
    {
      name: 'Pricing',
      to: '/pricing',
      icon: CurrencyDollarIcon,
      allowed: ['internal'],
    },
    {
      name: 'Tags',
      to: '/tags',
      icon: TagIcon,
      allowed: ['customer'],
    },
    {
      name: 'Orders',
      to: '/orders',
      icon: InboxIcon,
      allowed: ['internal'],
    },
    {
      name: 'Statistics',
      to: '/stats',
      icon: ChartPieIcon,
      allowed: ['customer', 'data_partner'],
    },
    {
      name: 'Data Partner Uploading',
      to: '/datapartner/upload',
      icon: UploadIcon,
      allowed: ['data_partner'],
    },
    // Temporarily disabled - KEN-2408: global dataset view crashes Openda
    // {
    //   name: 'Manage Datasets',
    //   to: '/admin/datasets',
    //   exact: true,
    //   icon: DatabaseIcon,
    //   allowed: ['admin'],
    // },
    {
      name: 'Batch Administrator',
      to: '/admin/datasets/batch',
      icon: ChartBarIcon,
      pathMatches: ['/admin/datasets/batch', '/admin/datasets/batch/new'],
      allowed: ['admin'],
    },
    {
      name: 'Manage Datasets Orders',
      to: '/admin/orders',
      exact: true,
      icon: InboxIcon,
      allowed: ['admin'],
    },
    {
      name: 'Manage Users',
      to: '/admin/users',
      icon: UserIcon,
      allowed: ['admin'],
    },
    {
      name: 'Sample Downloads',
      to: '/admin/datapartner/download',
      icon: DownloadIcon,
      allowed: ['admin'],
    },
    {
      name: 'Review Datasets',
      to: '/admin/datasets/review',
      exact: true,
      icon: DocumentReportIcon,
      allowed: ['admin'],
    },
    {
      name: 'Review Datasets Bulk',
      to: '/admin/datasets/review-bulk',
      exact: true,
      icon: DocumentReportIcon,
      allowed: ['admin'],
    },
    {
      name: 'Synthetic Data',
      to: '/synthetic',
      exact: true,
      icon: InboxIcon,
      allowed: ['internal'],
    },
    {
      name: 'Manage Synthetic Data Users Credit',
      to: '/admin/synthetic/credits',
      icon: UserIcon,
      allowed: ['admin'],
    },
    {
      name: 'Tools',
      to: '/tools',
      icon: HiOutlineWrench,
      allowed: ['internal'],
    },
  ],
];

export const navigationLinkGroupSecondary: NavigationLink[] = [
  {
    name: 'Demos and Guides',
    to: 'https://www.segmed.ai/resources/help',
    external: true,
  },
];
